/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkConditionsWithOrigin
 */
export interface WorkConditionsWithOrigin {
    /**
     * 
     * @type {Origin}
     * @memberof WorkConditionsWithOrigin
     */
    origin: Origin;
    /**
     * 
     * @type {WorkConditions}
     * @memberof WorkConditionsWithOrigin
     */
    workCondition: WorkConditions;
}

/**
 * Check if a given object implements the WorkConditionsWithOrigin interface.
 */
export function instanceOfWorkConditionsWithOrigin(value: object): value is WorkConditionsWithOrigin {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('workCondition' in value) || value['workCondition'] === undefined) return false;
    return true;
}

export function WorkConditionsWithOriginFromJSON(json: any): WorkConditionsWithOrigin {
    return WorkConditionsWithOriginFromJSONTyped(json, false);
}

export function WorkConditionsWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkConditionsWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': OriginFromJSON(json['origin']),
        'workCondition': WorkConditionsFromJSON(json['workCondition']),
    };
}

export function WorkConditionsWithOriginToJSON(value?: WorkConditionsWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'origin': OriginToJSON(value['origin']),
        'workCondition': WorkConditionsToJSON(value['workCondition']),
    };
}

